export const fetchAndSetOptions = async (url, selectElement, defaultValue) => {
    if (!url || !selectElement) {
        throw new Error('Missing required parameters');
    }

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error while fetching options. status: ${response.status}`);
        }

        const data = await response.json();

        if (data.length) {
            // Clear existing options
            selectElement.innerHTML = '';

            // Create document fragment for better performance
            const fragment = document.createDocumentFragment();

            data.forEach((item) => {
                const option = document.createElement('option');
                option.value = item.id;
                option.textContent = item.label;
                fragment.appendChild(option);
            });

            selectElement.appendChild(fragment);
        }

    } catch (error) {
        console.error(`Error fetching options from ${url}:`, error);
        throw error; // Re-throw to allow caller to handle
    }
};
